<template>
  <base-modal
    :title="'Oops, we encountered an error!'"
    :width="380"
    :close-button="false"
  >
    <div class="wrapper">
      <svg-icon
        :width="'96'"
        :height="'96'"
        fill="#db841e"
        icon="app-icons/error"
      />
      <p>
        Don't worry, this is totally on us and we have been notified about it.
        it. Feel free to contact us on
        <a href="https://discord.gg/atVXxAK" target="_blank"> Discord </a>
        or by
        <a href="mailto:sales@arcweave.com" target="_blank"> email </a>
        to let us know more information.
      </p>
      <p>Status code: {{ statusCode }}</p>
      <p>Please refresh your browser to continue working.</p>
      <div class="button" @click="onClickRefresh">Reload page</div>
    </div>
  </base-modal>
</template>

<script>
import { mapActions } from 'vuex';
import SvgIcon from '../all/SvgIcon.vue';
import BaseModal from './BaseModal.vue';

export default {
  components: {
    BaseModal,
    SvgIcon,
  },
  props: {
    /**
     * The status code of the request that is responsible for opening this modal
     */
    statusCode: {
      type: Number,
      default: 200,
    },
  },
  methods: {
    ...mapActions('application/modals', ['setErrorModal']),

    onClickRefresh() {
      window.location.reload(true);
      this.setErrorModal({ value: null });
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  padding: 20px;
}
.svg-icon-container {
  margin: 10px 0 30px 0;
}

.modal .icon-error {
  display: block;
  text-align: center;
  margin: 5px auto 30px auto;
}

.modal p {
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  margin: 0 0 20px 0;
  span {
    color: #fff;
    font-weight: bold;
  }
}

.modal .button {
  padding: 14px 18px;
  border-radius: 3px;
  width: 100%;
  border: none;
  color: #fff;
  background: #db841e;
  cursor: pointer;
  margin: 0;
  text-align: center;
  position: relative;
  -webkit-transition: background 0.25s;
  transition: background 0.25s;
  font-size: 16px;
  font-weight: 600;
}

.modal button:hover {
  background: #db841e;
}
</style>
